<template lang="pug">
vm-prompt(vm-size="medium" @vm-cancel="close" @vm-accept="saveOrder" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalCustomerPurchaseOrderVisible" :vm-title="$t('projects.add_purchase_order')")
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.form.$invalid },]")
    vm-col(vm-justify="center", vm-align="center", vm-w=6)
      b-form-group.separator
        vm-input(:placeholder='$t("customer_purchase_orders.number_placeholder")' :danger="$v.form.number.$invalid && $v.form.number.$model" :danger-text="$t('validation.required', { attribute: $t('customer_purchase_orders.number') })" v-model="form.number" :label='$t("customer_purchase_orders.number")')
    vm-col(vm-justify="center", vm-align="center", vm-w=6)
      b-form-group.separator
        vm-input(:placeholder='$t("customer_purchase_orders.folio_placeholder")' v-model="form.folio" :label='$t("customer_purchase_orders.folio")')
    vm-col(vm-justify="center", vm-align="center", vm-w=3)
      b-form-group.separator
        label.vm-input--label {{ $t('quotations.currency') }}
        .radio-section.d-flex.margin-left
          .radio-item(v-for='(currency, index) in catalog.currencies' :key="index")
            input(type="radio" :value="currency.id" :id="currency.id" v-model="form.currency_id")
            label.radio-margin(:for="currency.id") {{ currency.code }}
    vm-col(vm-justify="center", vm-align="center", vm-w=3)
      b-form-group.separator
        label.vm-input--label {{ $t('quotations.tax_type') }}
        .radio-section.d-flex.margin-left
          .radio-item
            input.radio-margin(type="radio" value=0 id="tax_0" v-model="form.tax_type")
            label.radio-label(for="tax_0") 0%
          .radio-item
            input.radio-margin(type="radio" value=8 id="tax_8" v-model="form.tax_type")
            label.radio-label(for="tax_8") 8%
          .radio-item
            input.radio-margin(type="radio" value=16 id="tax_16" v-model="form.tax_type")
            label.radio-label(for="tax_16") 16%
    vm-col(vm-justify="center", vm-align="center", vm-w=6)
      b-form-group.separator
        vm-input(v-if="form.currency_id === 2" v-model="form.exchange_rate" :placeholder='$t("customer_purchase_orders.exchange_rate_placeholder")' :danger="$v.form.exchange_rate.$invalid && $v.form.exchange_rate.$model" :danger-text="$t('validation.required', { attribute: $t('customer_purchase_orders.exchange_rate') })" :label='$t("customer_purchase_orders.exchange_rate")')
    vm-col(vm-justify="center", vm-align="center", vm-w=6)
      b-form-group.separator
        vm-input(:placeholder='$t("customer_purchase_orders.requisitor_placeholder")' :danger="$v.form.requisitor.$invalid && $v.form.requisitor.$model" :danger-text="$t('validation.required', { attribute: $t('customer_purchase_orders.requisitor') })" v-model="form.requisitor" :label='$t("customer_purchase_orders.requisitor")')
    vm-col(vm-justify="center", vm-align="center", vm-w=6)
      b-form-group.separator
        vm-select(:placeholder='$t("customer_purchase_orders.payment_deadline_placeholder")' :danger="$v.form.payment_deadline.$invalid && $v.form.payment_deadline.$model" :danger-text="$t('validation.required', { attribute: $t('customer_purchase_orders.payment_deadline') })" v-model="form.payment_deadline" :label='$t("customer_purchase_orders.payment_deadline")')
          vm-select-item(:key="index" :value="item.value" :text="item.value" v-for="(item,index) in paymentDeadlines")
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        .attached-custom
        .attached-custom__card(@dragover='dragover' @dragleave='dragleave' @drop="drop")
          div(class="attached-custom__card__placeholder" v-if='!this.filelist.length')
            label(for='files')
              span {{ $t('quotations.description_attached') }}
            vm-button(@click="onDialogFileOpen" size="medium" icon="cloud-upload-outline")
          div(class="attached-custom__card__grid" v-else='')
            div(class="attached-custom__card__grid__item" v-for='(file, index) in filelist' :key="index")
              header
                img(src='@/assets/icons/excel.svg')
                span {{ getFileNameFormated(file.name) }}
                .attached-custom__card__grid__item__dropdown
                  vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                    vm-button(type="flat" icon="more-vertical" color="#afbbc6" size="small")
                    vm-dropdown-menu
                      vm-dropdown-item.d-flex.justify-content-between(@click="remove(index, file)")
                        vm-icon(icon="trash-2-outline")
                        slot &nbsp;{{ $t('strings.delete') }}
        input(class="attached-custom__file" id="files" type='file' multiple='' name='fields[files][]' @change='onChange' ref='file' accept='.xls,.xlsx,spread,.csv')
        slot Descarga una
          a(@click="downloadTemplate({ model: 'customer-purchase-order-details' })") &nbsp;plantilla de CSV de muestra
          slot &nbsp;para ver un ejemplo del formato requerido.
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required, requiredIf } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
import { VUploaderFile } from '@/components/uploader-file'
const { mapGetters, mapActions } = createNamespacedHelpers('Projects')

export default {
  name: 'ModalProjectCustomerPurchaseOrders',
  components: {
    VUploaderFile
  },
  mixins: [ModalMixin1],
  data: () => ({
    filelist: [],
    paymentDeadlines: [
      {
        value: 30
      },
      {
        value: 45
      },
      {
        value: 60
      },
      {
        value: 90
      },
      {
        value: 120
      }
    ]
  }),
  validations () {
    return {
      form: {
        number: {
          required
        },
        exchange_rate: {
          required: requiredIf(() => this.form.currency_id === 2)
        },
        requisitor: {
          required
        },
        payment_deadline: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalCustomerPurchaseOrderVisible', 'catalog', 'details'])
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'setModalCustomerPurchaseOrderVisible',
      'loadCatalog',
      'addPurchaseOrder',
      'downloadTemplate',
      'makeRecordsFromExcel',
      'setProductDetails'
    ]),
    onDialogFileOpen () {
      this.$refs.file.click()
    },
    onShowFile (file) {
      const ext = file.name.split('.').pop()
      if (file.id && ext === 'pdf') {
        this.$viewer.show({
          urlFile: file.file_url,
          mime: file.mime_type,
          name: file.name,
          color: '#FFF'
        })
      } else if (file.id && ext !== 'pdf') {
        this.openFile(file.file_url)
      }
    },
    onChange () {
      this.filelist.push(...this.$refs.file.files)
      this.makeRecordsFromExcel({ file: [...this.$refs.file.files], id: this.form.id })
    },
    async remove (index, file) {
      this.filelist.splice(index, 1)
      this.setProductDetails([])
    },
    dragover (event) {
      event.preventDefault()
      if (!event.currentTarget.classList.contains('attached-custom__card--dragover')) {
        event.currentTarget.classList.add('attached-custom__card--dragover')
      }
    },
    dragleave (event) {
      event.currentTarget.classList.remove('attached-custom__card--dragover')
    },
    drop (event) {
      event.preventDefault()
      this.$refs.file.files = event.dataTransfer.files
      this.onChange()
      event.currentTarget.classList.remove('attached-custom__card--dragover')
    },
    getFileNameFormated (file) {
      return file.replace(/\.[^/.]+$/, '')
    },
    saveOrder () {
      let payload = {
        project_id: this.form.id,
        number: this.form.number,
        folio: this.form.folio,
        customer: this.form.customer_display,
        currency_id: this.form.currency_id,
        exchange_rate: this.form.exchange_rate,
        requisitor: this.form.requisitor,
        tax_type: this.form.tax_type,
        payment_deadline: this.form.payment_deadline,
        details: this.details
      }
      this.addPurchaseOrder(payload)
    },
    close () {
      this.setModalCustomerPurchaseOrderVisible(false)
    }
  }
}
</script>
<style lang="scss" scoped>
  .margin-left {
    margin-left: 10px;
  }
  .radio-margin {
    margin-right: 5px;
  }
  .attached-custom {
  margin: 20px 0;
  &__card {
    background-color: #F2F4F7;
    display: flex;
    min-height: 100px;
    border-radius: 8px;
    border: 3px dashed #B1B1B1;
    padding: 25px 35px;
    position: relative;
    &--dragover {
      background-color: rgba($color: var(--success), $alpha: 0.5);
      border: 3px dashed rgba($color: var(--success), $alpha: 1.0);
    }
    &__placeholder {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      & label {
        margin: 16px 0 10px 0;
        & span {
          font-size: 14px;
          font-weight: 400;
          color: #8A8A8A;
        }
      }
      & button {
        border-radius: 25px;
        font-weight: 700;
        font-size: 16px;
      }
    }
    &__grid {
      width: 100%;
      &__item {
        background-color: white;
        border-radius: 0.5em;
        box-shadow: 0px 4px 9px 0px rgba(0,0,0,0.25);
        -webkit-box-shadow: 0px 4px 9px 0px rgba(0,0,0,0.25);
        -moz-box-shadow: 0px 4px 9px 0px rgba(0,0,0,0.25);
        cursor: pointer;
        &__dropdown {
          position: absolute;
          top: 0;
          right: 0;
        }
        & header {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 80px;
          border-bottom: 1px solid #f0f0f0;
          padding: 10px;
          position: relative;
          img {
            width: 30px;
            margin-right: 10px;
          }
          span {
            font-size: 11px;
          }
        }
      }
    }
  }
  &__file {
    display: none;
  }
  &__upload {
    position: absolute;
    bottom: 5px;
    right: 5px;
    border-radius: 50%;
  }
  // remove clasess
  &__text {
    font-weight: bold;
  }
  &__note {
    label {
      color: black;
      font-weight: bold;
    }
  }
}
</style>
